import(/* webpackMode: "eager" */ "/home/u922493058/domains/jotform.aayyan.net/hbuilds/source/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ClientErrorLogger"] */ "/home/u922493058/domains/jotform.aayyan.net/hbuilds/source/components/ClientErrorLogger.tsx");
